import { render } from "./markets.vue?vue&type=template&id=7242e991"
import script from "./markets.vue?vue&type=script&lang=js"
export * from "./markets.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__